/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Lot_SizeInputs */

const cs_form_lot_size = /** @type {(inputs: Form_Lot_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozemek (m²)`)
};

const en_form_lot_size = /** @type {(inputs: Form_Lot_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lot size (m²)`)
};

/**
* | output |
* | --- |
* | "Lot size (m²)" |
*
* @param {Form_Lot_SizeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_lot_size = /** @type {((inputs?: Form_Lot_SizeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Lot_SizeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_lot_size(inputs)
	return cs_form_lot_size(inputs)
});